import React, {Component} from 'react';
import {Grid, Col, Row, Button,ControlLabel, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';


export default class AdminInventoryReconSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
var self = this;
var filterOptions = {
    searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
    SaleTransactionStatuses:  _.isUndefined(this.props.location.query.SaleTransactionStatuses) ? [  ] : _.isArray(this.props.location.query.SaleTransactionStatuses) ? _.map(this.props.location.query.Statuses, function (status) {
        return _.find(config.transactionStatusMap, {value:status})
    }) : [_.find(config.transactionStatusMap, {value:this.props.location.query.SaleTransactionStatuses})],
    perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
    //   Type: _.isUndefined(this.props.location.query.Type) ? '' : this.props.location.query.Type,
    sellers:  _.isUndefined(this.props.location.query.sellers) ? [  ] : _.isArray(this.props.location.query.sellers) ? _.map(this.props.location.query.sellers, function (seller) {
         return _.find(self.props.sellersOptionsList, {value:seller})
    }) : [_.find(this.props.sellersOptionsList, {value:this.props.location.query.sellers})],
     from:_.isUndefined(this.props.location.query.from) ?  '' : moment(this.props.location.query.from),
    to:_.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to),
    fromFD:_.isUndefined(this.props.location.query.fromFD) ? '' : moment(this.props.location.query.fromFD),
    toFD:_.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.toFD),
}

        this.state = {
            filterOptions: filterOptions
        };

    };
    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.sellersOptionsList) !== _.size(this.props.sellersOptionsList)) {
          this.setState({
              sellers: _.isUndefined(this.props.location.query.sellers) ? null : _.map(this.props.location.query.sellers, function (sellerID) {
                  var foundSeller = _.find(nextProps.sellersOptionsList, seller =>{
                      return sellerID == seller.value
                  })
                  return  {value:foundSeller.value, label:foundSeller.label}
              })
          })
        }
    }
    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        console.log('filterOptions', filterOptions);
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (_.size(filterOptions.sellers)) {
            queryParams.sellers = _.map(filterOptions.sellers, 'value')
        }

        if (filterOptions.from &&  moment(filterOptions.from, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.from = filterOptions.from.startOf('day').toISOString()
        }
        if (filterOptions.fromFD &&  moment(filterOptions.fromFD, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromFD = filterOptions.fromFD.startOf('day').toISOString()
        }
        if (_.size( filterOptions.SaleTransactionStatuses)) {
            queryParams.SaleTransactionStatuses = _.map(filterOptions.SaleTransactionStatuses, 'value')
        }
        if (filterOptions.to &&  moment(filterOptions.to, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.to = filterOptions.to.endOf('day').toISOString()
        }
        if (filterOptions.toFD &&  moment(filterOptions.toFD, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toFD = filterOptions.toFD.endOf('day').toISOString()
        }
        return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }


    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
        console.log('this.state.filterOptions', this.state.filterOptions  );
         var self = this;
        return (
            <div className="product-search-block">
                <Row  >
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Button className="btn btn-primary" onClick={this.props.toggleAllRecordsSelection}>
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>


                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                </Row>
                <Row  >


                    <Col xs={6} sm={4} md={4} lg={3}className="top10">
                        <Select
                            tabIndex="0"
                            searchable={true}
                            selectedOptions
                            multi
                             clearable={true}
                            placeholder="Sellers"
                            options={this.props.sellersOptionsList}
                            // options={ this.props.foundContractorsList }
                            onChange={ (selectedOptions) => {


                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        sellers:  selectedOptions ,
                                    }
                                }, function () {
                                  this.props.search()
                                })
                            }}
                            value={this.state.filterOptions.sellers}
                        />

                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3}className="top10">

                        <Select
                            tabIndex="0"
                            multi
                            placeholder="Transaction Status"
                            clearable={true}
                            options={[
                                {value: 'Sold', label: 'Sold'},

                                ]}
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        SaleTransactionStatuses: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.SaleTransactionStatuses}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              from: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{ placeholder: 'Products From created at' }}

                                  value={this.state.filterOptions.from}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              to: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{ placeholder: 'Products To created at' }}
                                  value={this.state.filterOptions.to}
                        />
                    </Col>

                </Row>

                <Row  >

                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromFD: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{ placeholder: 'From fulfilled at' }}

                                  value={this.state.filterOptions.fromFD}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toFD: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{ placeholder: 'To fulfilled at' }}
                                  value={this.state.filterOptions.toFD}
                        />
                    </Col>

                </Row>
                <Row>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>

                </Row>
            </div>
        );

    }
}



